import { Booking } from './models';

export type MatchMode = 'and' | 'or';

export const normalize = (value: string): string => {
  return value.toLowerCase().trim().replace(/\s+/g, ' ');
};

export const matchesAnd = (haystack: string, query: string): boolean => {
  const words = normalize(query).split(' ').filter(Boolean);
  return words.every((w) => haystack.includes(w));
};

export const matchesOr = (haystack: string, query: string): boolean => {
  const words = normalize(query).split(' ').filter(Boolean);
  return words.some((w) => haystack.includes(w));
};

export const buildHaystack = (booking: Booking): string => {
  const chunks: string[] = [];

  const invoiceNumber = booking.cruiseDetails?.invoiceNumber;
  if (invoiceNumber) chunks.push(String(invoiceNumber));

  const tourCode = booking.duration?.tourCode;
  if (tourCode) chunks.push(tourCode);

  const guides = booking.guides ? Object.values(booking.guides) : [];
  for (const guide of guides) {
    const forename = guide.guideDetails?.forename;
    const surname = guide.guideDetails?.surname;

    if (forename) chunks.push(forename);
    if (surname) chunks.push(surname);

    const otherValues = guide.other;
    if (otherValues) {
      for (const other of Object.values(otherValues)) {
        if (other) chunks.push(other);
      }
    }
  }
  return normalize(chunks.join(' '));
};

export const matchesSearchTerm = (
  haystack: string,
  term: string,
  mode: MatchMode,
): boolean => {
  const query = normalize(term);
  if (!query) return true;

  const words = query.split(' ').filter(Boolean);
  if (words.length === 0) return true;

  return mode === 'and'
    ? words.every((w) => haystack.includes(w))
    : words.some((w) => haystack.includes(w));
};
